import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * PaymentCanceled — shown when the user clicks "Back" on Stripe Checkout.
 */
export default function PaymentCanceled() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.iconWrap} aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24" fill="rgba(217,119,6,0.1)" />
            <path d="M24 16v10M24 30v2" stroke="#d97706" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        </div>

        <h1 style={styles.headline}>Payment canceled</h1>
        <p style={styles.body}>
          No worries, nothing was charged. You can upgrade whenever you're ready.
        </p>

        <div style={styles.btnGroup}>
          <button
            id="payment-canceled-upgrade-btn"
            onClick={() => navigate('/pricing')}
            style={styles.btnPrimary}
          >
            View Plans
          </button>
          <button
            id="payment-canceled-dashboard-btn"
            onClick={() => navigate('/dashboard')}
            style={styles.btnSecondary}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(160deg, #f8fafc 0%, #fffbeb 100%)',
    fontFamily: 'var(--font-body)',
    padding: '24px',
  },
  card: {
    background: 'rgba(255,255,255,0.9)',
    backdropFilter: 'blur(24px)',
    WebkitBackdropFilter: 'blur(24px)',
    border: '1px solid rgba(217,119,6,0.2)',
    borderRadius: 'var(--radius-xl)',
    padding: '48px 40px',
    maxWidth: 440,
    width: '100%',
    textAlign: 'center',
    boxShadow: 'var(--shadow-xl)',
    animation: 'rz-fadeIn 0.5s cubic-bezier(0.16,1,0.3,1)',
  },
  iconWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 24,
  },
  headline: {
    fontFamily: 'var(--font-heading)',
    fontSize: '1.9rem',
    fontWeight: 800,
    letterSpacing: '-0.04em',
    color: 'var(--color-text-primary)',
    marginBottom: 12,
  },
  body: {
    color: 'var(--color-text-secondary)',
    lineHeight: 1.6,
    marginBottom: 32,
  },
  btnGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  btnPrimary: {
    background: 'linear-gradient(135deg, var(--color-accent-ferrari), var(--color-purple-600))',
    color: '#fff',
    border: 'none',
    borderRadius: 'var(--radius-md)',
    padding: '12px 28px',
    fontFamily: 'var(--font-heading)',
    fontWeight: 700,
    fontSize: '0.95rem',
    cursor: 'pointer',
    transition: 'all var(--transition-base)',
  },
  btnSecondary: {
    background: 'transparent',
    color: 'var(--color-text-secondary)',
    border: '1px solid var(--color-border)',
    borderRadius: 'var(--radius-md)',
    padding: '12px 28px',
    fontFamily: 'var(--font-heading)',
    fontWeight: 600,
    fontSize: '0.95rem',
    cursor: 'pointer',
    transition: 'all var(--transition-base)',
  },
};
